import { useSyncLocalStorage } from 'src/hooks/useSyncLocalStorage';
import { OrderbookGrouping } from '@drift/common';
import { useCallback } from 'react';

const STORAGE_KEY = 'orderbook-grouping-preferences';

type GroupingPreferences = Record<string, OrderbookGrouping>;

export const useOrderbookGroupingPreferences = (marketId: string) => {
	const [preferences, setPreferences] =
		useSyncLocalStorage<GroupingPreferences>(STORAGE_KEY, {});

	const getGroupingSize = useCallback(
		(defaultSize: OrderbookGrouping): OrderbookGrouping => {
			return preferences[marketId] ?? defaultSize;
		},
		[preferences, marketId]
	);

	const setGroupingSize = useCallback(
		(groupingSize: OrderbookGrouping) => {
			setPreferences((prev) => ({
				...prev,
				[marketId]: groupingSize,
			}));
		},
		[marketId, setPreferences]
	);

	return {
		getGroupingSize,
		setGroupingSize,
	};
};
